export const SET_USER_OUT_CITY = "permission/SET_USER_OUT_CITY";
export const SET_USER_PROMPT_LOCATION = "permission/SET_USER_PROMPT_LOCATION";

const STORAGE_KEYS = {
  LOCATION_PROMPT: 'whicart_location_prompt',
  OUT_OF_CITY: 'whicart_out_of_city'
};

const isLocationPromptExpired = () => {
  const lastPrompt = localStorage.getItem(STORAGE_KEYS.LOCATION_PROMPT);
  if (!lastPrompt) return true;

  const lastPromptDate = new Date(lastPrompt);
  const now = new Date();
  const weekInMs = 7 * 24 * 60 * 60 * 1000;
  return now - lastPromptDate > weekInMs;
};

// Get initial state from localStorage
const getInitialState = () => {
  const isUserPromtedForLocation = !isLocationPromptExpired();
  const isUserOutOfCity = localStorage.getItem(STORAGE_KEYS.OUT_OF_CITY) === 'true';

  return {
    isUserOutOfCity,
    isUserPromtedForLocation
  };
};

const initialState = getInitialState();

export const permissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_OUT_CITY:
      localStorage.setItem(STORAGE_KEYS.OUT_OF_CITY, action.payload);
      return {
        ...state,
        isUserOutOfCity: action.payload,
        isUserPromtedForLocation: true
      }
    case SET_USER_PROMPT_LOCATION:
      if (action.payload) {
        localStorage.setItem(STORAGE_KEYS.LOCATION_PROMPT, new Date().toISOString());
      }
      return {
        ...state,
        isUserPromtedForLocation: action.payload
      }
    default:
      return state;
  }
};

export const setUserOutOfCity = (isOutOfCity) => {
  return {
    type: SET_USER_OUT_CITY,
    payload: isOutOfCity,
  };
};

export const setUserPromtedForLocation = (asked) => {
  return {
    type: SET_USER_PROMPT_LOCATION,
    payload: asked,
  };
};

export default permissionReducer;
